import { FieldSchema, FieldValueObject, isEmpty, EMPTY_VALUE } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { getEquipmentCategories } from "../external-sources/CategoryMappings";
import { SchemaContext } from "../../common";
import { Modes } from "./mode";

export const createEquipmentCategory = (context: SchemaContext): FieldSchema => ({
  grid: {
    displayed: true,
    order: 12,
    filter: GridFilterTypes.SET,
    // Set filter without a `data` enum: the form assigns this through the MasterDataPicker,
    // so the options are grid-scoped. Merges equipment and cluster categories, because the
    // grid lists both kinds of row.
    filterValues: { getter: () => getEquipmentCategories(context.client) },
  },
  name: "equipmentCategory",
  data: {
    assignedValue: {
      getter: ({ equipmentCategory, masterDataPicker, mode }) => {
        // A CSV names this in a column of its own, and the picker being read here is the one
        // rebuilt from the stored record — so deferring to it would drop what the file said.
        if (masterDataPicker && mode !== Modes.CSV) {
          return (masterDataPicker as FieldValueObject)?.equipmentCategory ?? EMPTY_VALUE;
        }
        return isEmpty(equipmentCategory) ? EMPTY_VALUE : equipmentCategory;
      },
      fields: ["masterDataPicker", "mode"],
    },
  },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: {
    label: "Category",
    disabled: {
      getter: ({ linkedInstance, mode, currentUser }) => {
        return (
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["linkedInstance", "mode", "currentUser"],
    },
  },
});
